import React from 'react';

const APP_BLOCKED = 3;
const APP_DISABLED = 5;


export const appIsDisabled = (idsituacao) => idsituacao == APP_DISABLED;

export const appIsBlocked = (idsituacao) => idsituacao == APP_BLOCKED;